<div class="dpe-cell fx-layout-row fx-justify-start fx-align-center">
  @if (colorClass) {
    <div [ngClass]="colorClass" class="label-content dpe-label-content not-hoverable">
      {{ value }}
    </div>
  } @else {
    <span>{{ emptyValue }}</span>
  }
</div>
